export const getCountriesListWithMainCountryOnTop = countries => {
    return countries?.reduce((acc, country) => {
        if (__ORIGIN_COUNTRY__ === country.value) {
            return [country, ...acc];
        }

        return [...acc, country];
    }, []);
};
